/* eslint-disable no-console */
import {LeftOutlined} from '@ant-design/icons';
import {Col, Flex, Row, Typography, Button, Image} from 'antd';
import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import NonRenewableForm from '../../../components/Forms/NonRenewable';
import Loader from '../../../components/Loader/Loader';
// import PageContent from '../../../components/PageContent/PageContent';
import CustomTable from '../../../components/Table/CustomTable';
import ModalForm from '../../../components/Table/Utils/FormModal';
import {allRoutes} from '../../../constants/Routes';
import electricityAPI from '../../../services/modules/IP/electricityAPI';
import {convertData} from '../constants/commonFunctions';
import PDFRender from '../PDFRender';
import SVGBoundingBox from '../SVGBoundingBox';

const DisplayOCR: React.FC = () => {
  const navigate = useNavigate();
  const [imageDimensions, setImageDimensions] = useState({width: 0, height: 0});
  const [isPDF, setIsPDF] = useState(false);
  const location = useLocation();
  const [showModel, setShowModel] = useState(false);
  const [, setRefresh] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [showData, setShowData] = useState<any>({});
  const [originalData, setOriginalData] = useState<any | undefined>();
  // const [facilitySelected, setFacilitySelected] = useState<any | undefined>(
  //   undefined
  // );
  const [bb, setBB] = useState<any>();
  const [imgLoaded, setImgLoaded] = useState(false);
  const type = 'Non-renewable';

  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = (ref: any) => {
    if (ref) {
      const reff = ref.getBoundingClientRect();
      setImageDimensions({
        width: reff.width,
        height: reff.height
      });
    }
    setImgLoaded(true);
  };

  useEffect(() => {
    if (!!location.state) {
      const loState = location.state;
      const loSplit = loState?.showData.location.split('.');
      setShowData(loState?.showData);
      setBB(loState.bb);
      setIsLoading(false);
      setIsPDF(loSplit[loSplit.length - 1] === 'pdf');
      // setFacilitySelected(loState.facilityDetails);
      setOriginalData(loState.original);
    }
  }, [location.state]);

  return isLoading ? (
    <Loader />
  ) : (
    <div
      style={{backgroundColor: 'white', padding: '20px', borderRadius: '20px'}}
    >
      <Button
        type="default"
        icon={<LeftOutlined />}
        onClick={() => {
          navigate({
            pathname: allRoutes.OCR.OCRMain,
            search: location.search
          });
        }}
      >
        Back
      </Button>
      <div style={{padding: '20px 0px'}}>
        <Flex vertical={false} align="center" justify="center">
          <div style={{position: 'relative', flex: 1}}>
            {isPDF ? (
              <PDFRender
                pdfUrl={showData.location}
                handleImageLoad={handleImageLoad}
                setPage={setPage}
                setImgLoaded={setImgLoaded}
              />
            ) : (
              <Image
                //   src={showData.location}
                //   ref={imageRef}
                src={showData.location}
                preview={false}
                style={{
                  // backgroundColor: '#f3f7ff',
                  width: '100%',
                  height: '100%',
                  flex: 1
                }}
                onLoad={(ref) => {
                  handleImageLoad(ref?.target);
                }}
              />
            )}
            {imgLoaded && (
              <SVGBoundingBox
                isPDF={isPDF}
                polygons={bb.polygon}
                imageDimension={imageDimensions}
                page={page}
              />
            )}
          </div>

          <Flex
            style={{
              flex: 1,
              // width: '100%',
              height: '100%',
              padding: '20px',
              alignSelf: 'flex-start'
            }}
            vertical
          >
            <Row gutter={[10, 10]}>
              {showData?.fields
                ?.filter((a: any) => {
                  return a.boundingBox;
                })
                .map((item: any, index: number) => {
                  return Array.isArray(item.value) ? (
                    item.value.length > 0 && (
                      <Col span={24} key={index}>
                        <CustomTable data={item} />
                      </Col>
                    )
                  ) : (
                    <Col span={8} key={index}>
                      <div>
                        <Typography.Title level={5}>
                          {item.label}
                        </Typography.Title>
                        <div>{item.value}</div>
                      </div>
                    </Col>
                  );
                })}
            </Row>
            {/* {showData.doc_type === '66e956203def64db6dd9b761' && (
              <Row
                align="middle"
                gutter={[10, 10]}
                style={{alignSelf: 'center'}}
              >
                <Col span={24}>
                  <Button
                    onClick={() => {
                      setShowModel(true);
                    }}
                    type="primary"
                  >
                    Submit Form
                  </Button>
                </Col>
              </Row>
            )} */}
            <ModalForm
              open={showModel}
              onCancel={() => {
                setShowModel(false);
              }}
              setRefresh={setRefresh}
              data={convertData(
                // showData.fields,
                {...originalData, year: showData.year},
                {
                  type: 'electricity',
                  unit: 'kWh'
                },
                {
                  type: 'cost',
                  unit: 'kWh'
                }
              )}
              FormComponent={<NonRenewableForm />}
              API={electricityAPI}
              title={'Add Non-Renewable'}
              idKey={`${showData.facility}/${showData.year}`}
              table={true}
              type={{key: 'renewableType', value: type}}
            />
          </Flex>
        </Flex>
      </div>
    </div>
  );
};

export default DisplayOCR;
